/**
 * @desc 查看视频监控摄像头列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.VideoMonitorListRequest,
): Promise<defs.StandardReturn<Array<defs.VideoMonitorResponse>>> {
  return defHttp.post({
    url: '/wap/ProductionRealTime/qryVideoMonitorList',
    data,
  });
}

export function mock(
  data: defs.VideoMonitorListRequest,
): Promise<defs.StandardReturn<Array<defs.VideoMonitorResponse>>> {
  return defHttp.post({
    url: '/mock/wap/ProductionRealTime/qryVideoMonitorList',
    data,
  });
}
